import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

// Another user's profile -- the same query key (and therefore the same
// cache entry) whether it's read from profile-view, a reveal-request
// row, or a Match card, so TanStack dedupes and a match already viewed
// via profile-view hits a warm cache instead of a second round trip.
// retry: false because a 404 is a stable outcome (deleted account,
// blocked viewer), not a transient failure.
export function useProfile(userId: string, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.profile(userId),
    queryFn: () => api.getProfile(userId),
    enabled: options?.enabled,
    retry: false,
  });
}
